export const BSCSCAN_URL = "https://bscscan.com"
